import { useThrottleFn } from 'ahooks';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useState } from 'preact/hooks';

export function usePaginationSwiper(options: Parameters<typeof useEmblaCarousel>[0]) {
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  const reInit = useCallback(() => {
    if (emblaApi) emblaApi.reInit();
  }, [emblaApi]);

  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const [emblaPaginationVisible, setEmblaPaginationVisible] = useState(true);

  const { run: watchSwiper } = useThrottleFn(
    () => {
      if (!emblaApi) return;
      const canScrollPrev = emblaApi.canScrollPrev();
      const canScrollNext = emblaApi.canScrollNext();

      setCanScrollPrev(canScrollPrev);
      setCanScrollNext(canScrollNext);
      // 当可以前后滚动时显示分页按钮
      setEmblaPaginationVisible(canScrollPrev || canScrollNext);
    },
    { wait: 300 },
  );

  useEffect(() => {
    if (!emblaApi) return;

    emblaApi.on('select', watchSwiper);
    emblaApi.on('slidesInView', watchSwiper);
    emblaApi.on('init', watchSwiper);
    emblaApi.on('reInit', watchSwiper);

    // 初始化时执行一次
    watchSwiper();

    return () => {
      emblaApi.off('select', watchSwiper);
      emblaApi.off('slidesInView', watchSwiper);
      emblaApi.off('init', watchSwiper);
      emblaApi.off('reInit', watchSwiper);
    };
  }, [emblaApi]);

  return {
    emblaRef,
    scrollPrev,
    scrollNext,
    reInit,
    canScrollPrev,
    canScrollNext,
    emblaPaginationVisible,
  };
}
